import { useRouter, useStore } from '../../core/hooks';
import { computed, ref } from '@vue/composition-api'

const useAuthCheck = openedFrom => {
    const { store, state } = useStore()
    const { router } = useRouter()
    const user = computed(() => state.value.user)
    const checkAuthState = () => {
        if(user.value && user.value.uid) {
            router.push('/browse').catch(() => {})
        }
        else {
            store.commit('TOGGLE_MODAL', ['sign-up', {
                openedFrom
            }]);
        }
    }
    return {
        checkAuthState
    }
}

export default useAuthCheck